import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import s from './HistoryEventsHeader.css';
import cx from 'classnames';
import HistoryEventsHeadereaderRow from './HistoryHeaderRow';
import Messages from './Messages';
import Select from '../SelectMultiple';
import Button from '../Button';
import Loader from '../Loader';
import Icon from '../Icon';
import Form from '../Form';
import { eventsParser, getOptionsTranslator } from '../../core/utils';

class HistoryEventsHeader extends React.Component {

  sanitazeItemsFetched = deviceDocumentPaging => {
    if (deviceDocumentPaging) {
      if (
        deviceDocumentPaging.get('itemsCount') < deviceDocumentPaging.get('itemsPerPage')
      ){
        return deviceDocumentPaging.get('itemsCount');
      }
      return (
        deviceDocumentPaging.get('numberOlderItemsFetched') * deviceDocumentPaging.get('itemsPerPage'));
    }
    return 0;
  }

  render() {
    const messages = Messages();
    const {
      events,
      intl,
      deviceType,
      filteredEvents,
      deviceDocumentPaging,
      deviceSerial,
      deviceName
    } = this.props;
    
    const eventsReady = events ? Object.entries(events).length : events;
    if (eventsReady) {
      const eventsOptions = events
        .toArray()
        .map(eventsParser)
        .map(getOptionsTranslator(intl, messages));
      const iconSize = 41;

      const isSuperior = deviceType === 'superior';
      const colorStyled = isSuperior ? cx(s.blackButton) : cx(s.whiteButton);
      const dark = isSuperior ? 'dark_spirotech' : 'dark';
      const light = isSuperior ? 'light_spirotech' : 'light';
      const edytuj = isSuperior ? 'edytuj_black' : 'edytuj';
      const clearFilter = isSuperior ? 'odrzuc' : 'odrzuc_white';
      const itemsFetched = this.sanitazeItemsFetched(deviceDocumentPaging);
      const itemsCount = deviceDocumentPaging.get('itemsCount');
      const downloadingDocument = deviceDocumentPaging.get('downloadingDocument');
      return (
        <section className={s.container}>
          <h3>{deviceName} S/N: {deviceSerial}</h3>
          <div className={s.center}> 
            <FormattedMessage { ...messages.record_part1_text} /> {itemsFetched} / {itemsCount}
            <FormattedMessage { ...messages.record_part2_text} />          
          </div>
          <div className={s.left}>

            <Form>
              <Select
                title={intl.formatMessage({
                  ...messages.filter_select_button_history,
                })}
                name="events"
                options={eventsOptions}
                onChange={this.props.onChange}
                large
                multiple
              />
            </Form>
          </div>
          <div className={s.right}>
            <Button 
              onClick={() => {
                if (!downloadingDocument) {
                  this.props.onSave(this.props.filteredEvents, true);
                }
              }}
              buttonClass="mainPdf"
              buttonColor={dark}
              title={intl.formatMessage(
                messages.save_as_pdf_button_history,
              )}
            >
              <Icon iconName={edytuj} size={iconSize} />
              <div className={colorStyled}>
                {!downloadingDocument ? (
                  <FormattedMessage {...messages.save_as_pdf_button_history} />
                ) : (<Loader/>)}
              </div>
            </Button>
            <Button 
              onClick={() => {
                if (!downloadingDocument) {
                  this.props.onSave(this.props.filteredEvents, false);
                }
              }}
              buttonClass="mainPdf"
              buttonColor={dark}
              title={intl.formatMessage(
                messages.save_all_as_pdf_button_history,
              )}
            >
              <Icon iconName={edytuj} size={iconSize} />
              <div className={colorStyled}>
                {!downloadingDocument ? (
                    <FormattedMessage {...messages.save_all_as_pdf_button_history} />
                ) : (<Loader/>)}
              </div>
            </Button>
            <Button
              onClick={() => {
                this.props.onClearFilter();
                this.props.onChange([]);
              }}
              buttonClass="mainPdf"
              buttonColor={light}
            >
              <Icon iconName={clearFilter} size={iconSize} />
              <div className={colorStyled}>
                <FormattedMessage {...messages.clear_filter_button_history} />
              </div>
            </Button>
          </div>
        </section>
      );
    } 
    return null;
  }
}

HistoryEventsHeader.propTypes = {
  events: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  intl: intlShape.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  filteredEvents: PropTypes.arrayOf(PropTypes.string).isRequired,
  deviceSerial: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
};

export default injectIntl(withStyles(s)(HistoryEventsHeader));



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEventsHeader.js